import L from "leaflet";

export default () => {

    const doms = document.querySelectorAll('[data-leaflet]');

    for (const dom of doms) {
        const lat = dom.getAttribute('data-lat');
        const lng = dom.getAttribute('data-lng');

        const map = L.map(dom, {
            center: [lat, lng],
            zoom: 15
        });

        L.tileLayer('https://api.mapbox.com/styles/v1/nivankafonseka/cky9ei3ua3r9514qwoyf0ltt4/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1Ijoibml2YW5rYWZvbnNla2EiLCJhIjoiY2t5OWVtcDl4MDVvNzJubW5yNGN2dGI4MyJ9.28FLF_e0rkyYxJxM7P-jsQ', {
            maxZoom: 18,
            id: 'mapbox/streets-v11',
            tileSize: 512,
            zoomOffset: -1,
            accessToken: 'pk.eyJ1Ijoibml2YW5rYWZvbnNla2EiLCJhIjoiY2piZXVqYjZmMnVqODMzcWdnNHRtNnpldCJ9.KsvDzV4jUau13c_RclgMmw'
        }).addTo(map);

        L.marker([lat, lng]).addTo(map);

    }


}
